import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from './auth.service';

/** Solo permite acceso a la carpeta 'guide' a usuarios con rol root. Redirige a /home si no es root. */
export const rootGuard: CanActivateFn = async (_route, state) => {
  const url = state.url || '';
  const folder = url.split('/')[2]; // view/guide/... -> 'guide'
  if (folder !== 'guide') return true;

  const router = inject(Router);
  const authService = inject(AuthService);
  const isRoot = await authService.isRoot();
  if (!isRoot) {
    router.navigate(['/home']);
    return false;
  }
  return true;
};
